// extracted by mini-css-extract-plugin
export default {"root":"ChipOptionsSelector_root__PiAV5","selected":"ChipOptionsSelector_selected__aMpTl","orientation_vertical":"ChipOptionsSelector_orientation_vertical__z3NFs"};